import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as analysisService from '../services/analysisService'
let dataBuilderInterval
let openCasino
class CasinoAnalysis extends Component {
	constructor(props) {
		super(props);
		this.state = {
			uid: "",
			passcode: "",
			eventTypes: [],
			casinoData: {},
			liveGames: {},
			virtualGames: {},
			isCasinoAnaMounted: false
		};
	}

	// async dataBuilder() {
	//   let userData = localStorage.getItem("tokenData")
	//   userData = JSON.parse(userData)
	//   if (!(!!userData && !!userData.sub)) {
	//     localStorage.clear();
	//     this.props.history.push("/auth")
	//   }
	//   let data = await analysisService.getCasinoListing(userData.sub)
	//   if (data.isSuccess) {
	//     let casinoData = {}
	//     !!data.items && Array.prototype.forEach.call(data.items, (elem, i) => {
	//       let competition_id = elem.competition_id.split('/')[1]
	//       // competition_id = competition_id[1]
	//       if (!!casinoData[competition_id]) {
	//         casinoData[competition_id].exposure = casinoData[competition_id].exposure + elem.exposure
	//         casinoData[competition_id].order_count = casinoData[competition_id].order_count + elem.order_count
	//         casinoData[competition_id].total_amount = casinoData[competition_id].total_amount + elem.total_amount
	//         casinoData[competition_id].max_profit = casinoData[competition_id].max_profit + elem.max_profit
	//       } else {
	//         casinoData[competition_id] = elem
	//       }
	//     })
	//     this.setState({ casinoData: casinoData })
	//   }
	// }

	async dataBuilder() {

		let userData = localStorage.getItem("tokenData")
		userData = JSON.parse(userData)
		if (!(!!userData && !!userData.sub)) {
			localStorage.clear();
			this.props.history.push("/auth")
		}

		let self = this;
		openCasino = setInterval(async function allOpenCasino() {
			clearInterval(openCasino)

			analysisService.getCasinoListing().then((res) => {
				if(self.state.isCasinoAnaMounted){
					if (!!res && !!res.items) {

						let casinoData = {}
						!!res.items && Array.prototype.forEach.call(res.items, (elem, i) => {

							let competition_id = elem.competitionId.split('/')[1]

							if (!!casinoData[competition_id]) {
								casinoData[competition_id].exposure = casinoData[competition_id].exposure + elem.exposure
								casinoData[competition_id].orderCount = casinoData[competition_id].orderCount + elem.orderCount
								casinoData[competition_id].totalAmount = casinoData[competition_id].totalAmount + elem.totalAmount
								casinoData[competition_id].maxProfit = casinoData[competition_id].maxProfit + elem.maxProfit
							}
							else {
								casinoData[competition_id] = elem
							}
						})

						self.setState({ casinoData: casinoData })

						let mkts = res.items

						openCasino = setInterval(allOpenCasino, 5000)

					} else {
						openCasino = setInterval(allOpenCasino, 5000)
					}
				}
			})
		}, 500)
	}

	componentDidMount() {
		this.setGames()
		this.setState({isCasinoAnaMounted : true},()=>{
			this.dataBuilder()
		})
		// dataBuilderInterval = setInterval(() => {
		//   clearInterval(dataBuilderInterval)
		//   this.dataBuilder()
		// }, 5000)
	}

	componentWillUnmount() {
		this.state.isCasinoAnaMounted = false;
		clearInterval(dataBuilderInterval)
		clearInterval(openCasino)
	}

	setGames(){
		let liveGames = {
			"56767": "Live Teenpatti",
			"56768": "Teenpatti T20",
			"56967": "32 Card Casino",
			"56968": "Hi Low",
			"67564": "Poker",
			"67565": "Six player poker",
			"67680": "The Trap",
			"87564": "Andar Bahar",
			"92037": "Matka",
			"98789": "7 Up & Down",
			"98790": "Dragon Tiger",
			"98791": "Amar Akbar Anthony",
			"90100": "Race 20-20",
			"67570": "Bollywood Casino",
			"98788": "Roulette",
			"98566": "Sicbo",
			"67600": "Muflis Teenpatti",
			"67610": "Trio",
			"92038": "Baccarat",
			"67575": "Casino Meter",
			"67567": "Poker 20-20",
			"67660": "2 Card Teenpatti",
			"67620": "Queen Race",
			"67630": "Teenpatti Test",
			"67640": "Teenpatti Open",
			"67580": "Casino War",
			"67690": "29 Card Baccarat",
			"67710": "Race to 17"
		}

		let virtualGames = {
			"98795": "Amar Akbar Anthony (virtual)",
			"56769": "Teenpatti T20 (virtual)",
			"98793": "7 Up & Down (virtual)",
			"98794": "Dragon Tiger (virtual)",
			"56766": "Teenpatti One Day (virtual)",
			"87565": "Andar Bahar (virtual)",
			"67566": "Six Player Poker (virtual)",
			"56969": "Hi Low (virtual)",
			"56966": "32 Card Casino (virtual)",
			"67563": "Poker (virtual)",
			"92036": "Matka (virtual)",
			"98792": "Roulette (virtual)"
		}
		

		this.setState({ liveGames: liveGames, virtualGames: virtualGames })
	}

	render() {
		return (
			<div className="bethubs">
				<Header history={this.props.history} />
				<div className="wrapper">
					<div className="container-fluid container-padding-0">
						<div className="row">
							<div className="col-12 col-sm-12 col-md-12 col-lg-12">
								<div className="main-box">
									<h5 className="text-blue">Indian Poker Analysis</h5>
									<div className="row marketanalysis mt-2">
										<div className="col-12 col-sm-12 col-md-12">
											<div className="marketanalysisbox mb-2">
												<div className="topbox font-16"><b>Live Casino</b></div>
												<div className="padd-10 table-responsive eventmaspage">
													<table className="table table-bordered font-14 w-100 whitespace mb-0">
														<thead>
															<tr className="bg-dark importeve">
																<td className="event-width40"><span className="font-weight-bold text-white">Event Name</span></td>
																<td className="event-width10 text-right"><span className="font-weight-bold text-white">Total Order</span></td>
																<td className="event-width12 text-right"><span className="font-weight-bold text-white">Exposure</span></td>
																<td className="event-width12 text-right"><span className="font-weight-bold text-white">Total Amount</span></td>
																<td className="event-width12 text-right"><span className="font-weight-bold text-white">Max Profit</span></td>
															</tr>
														</thead>
														<tbody className="bg-white">
															{!!Object.keys(this.state.liveGames).length > 0 && Object.keys(this.state.liveGames).map( (gameId, i) => {
																return(
																	<tr key={`live${i}`}>
																		<td>
																			<span className="font-weight-bold">
																				<a href={`/casinoanalysisuser/${gameId}`} className=" topboxlink">{this.state.liveGames[gameId]}</a>
																			</span>
																		</td>
																		<td className="text-right">
																			<span className="font-weight-bold">{!!this.state.casinoData[gameId] ? this.state.casinoData[gameId].orderCount : "0"}</span>
																		</td>
																		<td className="text-right">
																			<span className="font-weight-bold">
																				<span className={!!this.state.casinoData[gameId] && this.state.casinoData[gameId].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData[gameId] ? Math.round(this.state.casinoData[gameId].exposure) : "0"}</span>
																			</span>
																		</td>
																		<td className="text-right">
																			<span className="font-weight-bold">{!!this.state.casinoData[gameId] ? Math.round(this.state.casinoData[gameId].totalAmount) : "0"}</span>
																		</td>
																		<td className="text-right">
																			<span className="font-weight-bold">{!!this.state.casinoData[gameId] ? Math.round(this.state.casinoData[gameId].maxProfit) : "0"}</span>
																		</td>
																	</tr>
																)
															})}
															{/* <tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/56767"} className=" topboxlink">Live Teenpatti</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56767"] ? this.state.casinoData["56767"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["56767"] && this.state.casinoData["56767"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["56767"] ? Math.round(this.state.casinoData["56767"].exposure) : "00"}</span></span>
																</td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56767"] ? Math.round(this.state.casinoData["56767"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56767"] ? Math.round(this.state.casinoData["56767"].maxProfit) : "00"}</span></td>
															</tr>
															<tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/87564"} className=" topboxlink">Andar Bahar</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["87564"] ? this.state.casinoData["87564"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["87564"] && this.state.casinoData["87564"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["87564"] ? Math.round(this.state.casinoData["87564"].exposure) : "00"}</span></span>
																</td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["87564"] ? Math.round(this.state.casinoData["87564"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["87564"] ? Math.round(this.state.casinoData["87564"].maxProfit) : "00"}</span></td>
															</tr>
															<tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/67564"} className=" topboxlink">Poker</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["67564"] ? this.state.casinoData["67564"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["67564"] && this.state.casinoData["67564"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["67564"] ? Math.round(this.state.casinoData["67564"].exposure) : "00"}</span></span>
																</td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["67564"] ? Math.round(this.state.casinoData["67564"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["67564"] ? Math.round(this.state.casinoData["67564"].maxProfit) : "00"}</span></td>
															</tr>
															<tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/98789"} className=" topboxlink">7 up & 7 down</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["98789"] ? this.state.casinoData["98789"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["98789"] && this.state.casinoData["98789"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["98789"] ? Math.round(this.state.casinoData["98789"].exposure) : "00"}</span></span>
																</td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["98789"] ? Math.round(this.state.casinoData["98789"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["98789"] ? Math.round(this.state.casinoData["98789"].maxProfit) : "00"}</span></td>
															</tr>
															<tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/56967"} className=" topboxlink">32 cards casino</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56967"] ? this.state.casinoData["56967"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["56967"] && this.state.casinoData["56967"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["56967"] ? Math.round(this.state.casinoData["56967"].exposure) : "00"}</span></span>
																</td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56967"] ? Math.round(this.state.casinoData["56967"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56967"] ? Math.round(this.state.casinoData["56967"].maxProfit) : "00"}</span></td>
															</tr>
															<tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/56768"} className=" topboxlink">Teenpatti T20</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56768"] ? this.state.casinoData["56768"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["56768"] && this.state.casinoData["56768"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["56768"] ? Math.round(this.state.casinoData["56768"].exposure) : "00"}</span></span>
																</td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56768"] ? Math.round(this.state.casinoData["56768"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56768"] ? Math.round(this.state.casinoData["56768"].maxProfit) : "00"}</span></td>
															</tr>
															<tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/98791"} className=" topboxlink">Amar Akbar Anthony</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["98791"] ? this.state.casinoData["98791"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["98791"] && this.state.casinoData["98791"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["98791"] ? Math.round(this.state.casinoData["98791"].exposure) : "00"}</span></span>
																</td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["98791"] ? Math.round(this.state.casinoData["98791"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["98791"] ? Math.round(this.state.casinoData["98791"].maxProfit) : "00"}</span></td>
															</tr>
															<tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/98790"} className=" topboxlink">Dragon Tiger</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["98790"] ? this.state.casinoData["98790"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["98790"] && this.state.casinoData["98790"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["98790"] ? Math.round(this.state.casinoData["98790"].exposure) : "00"}</span></span>
																</td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["98790"] ? Math.round(this.state.casinoData["98790"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["98790"] ? Math.round(this.state.casinoData["98790"].maxProfit) : "00"}</span></td>
															</tr> */}
														</tbody>
													</table>
												</div>
											</div>
											<div className="marketanalysisbox mb-2">
												<div className="topbox font-16"><b>Virtual Casino</b></div>
												<div className="padd-10 table-responsive eventmaspage">
													<table className="table table-bordered font-14 w-100 whitespace  mb-0">
														<thead>
															<tr className="bg-dark importeve">
																<td className="event-width40"><span className="font-weight-bold text-white">Event Name</span></td>
																<td className="event-width10 text-right"><span className="font-weight-bold text-white">Total Order</span></td>
																<td className="event-width12 text-right"><span className="font-weight-bold text-white">Exposure</span></td>
																<td className="event-width12 text-right"><span className="font-weight-bold text-white">Total Amount</span></td>
																<td className="event-width12 text-right"><span className="font-weight-bold text-white">Max Profit</span></td>
															</tr>
														</thead>
														<tbody className="bg-white">
															{!!Object.keys(this.state.virtualGames).length > 0 && Object.keys(this.state.virtualGames).map( (gameId, i) => {
																return(
																	<tr key={`virtual${i}`}>
																		<td>
																			<span className="font-weight-bold">
																				<a href={`/casinoanalysisuser/${gameId}`} className=" topboxlink">{this.state.virtualGames[gameId]}</a>
																			</span>
																		</td>
																		<td className="text-right">
																			<span className="font-weight-bold">{!!this.state.casinoData[gameId] ? this.state.casinoData[gameId].orderCount : "0"}</span>
																		</td>
																		<td className="text-right">
																			<span className="font-weight-bold">
																				<span className={!!this.state.casinoData[gameId] && this.state.casinoData[gameId].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData[gameId] ? Math.round(this.state.casinoData[gameId].exposure) : "0"}</span>
																			</span>
																		</td>
																		<td className="text-right">
																			<span className="font-weight-bold">{!!this.state.casinoData[gameId] ? Math.round(this.state.casinoData[gameId].totalAmount) : "0"}</span>
																		</td>
																		<td className="text-right">
																			<span className="font-weight-bold">{!!this.state.casinoData[gameId] ? Math.round(this.state.casinoData[gameId].maxProfit) : "0"}</span>
																		</td>
																	</tr>
																)
															})}
															{/* <tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/67566"} className=" topboxlink">Six player poker (Virtual)</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["67566"] ? this.state.casinoData["67566"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["67566"] && this.state.casinoData["67566"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["67566"] ? Math.round(this.state.casinoData["67566"].exposure) : "00"}</span></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["67566"] ? Math.round(this.state.casinoData["67566"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["67566"] ? Math.round(this.state.casinoData["67566"].maxProfit) : "00"}</span></td>


															</tr>
															<tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/56766"} className=" topboxlink">Teenpatti One-Day (Virtual)</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56766"] ? this.state.casinoData["56766"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["56766"] && this.state.casinoData["56766"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["56766"] ? Math.round(this.state.casinoData["56766"].exposure) : "00"}</span></span>
																</td><td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56766"] ? Math.round(this.state.casinoData["56766"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56766"] ? Math.round(this.state.casinoData["56766"].maxProfit) : "00"}</span></td>

															</tr>
															<tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/87565"} className=" topboxlink">Andar Bahar (Virtual)</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["87565"] ? this.state.casinoData["87565"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["87565"] && this.state.casinoData["87565"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["87565"] ? Math.round(this.state.casinoData["87565"].exposure) : "00"}</span></span>
																</td><td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["87565"] ? Math.round(this.state.casinoData["87565"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["87565"] ? Math.round(this.state.casinoData["87565"].maxProfit) : "00"}</span></td>

															</tr>
															<tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/56769"} className=" topboxlink">Teenpatti T20 (Virtual)</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56769"] ? this.state.casinoData["56769"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["56769"] && this.state.casinoData["56769"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["56769"] ? Math.round(this.state.casinoData["56769"].exposure) : "00"}</span></span>
																</td><td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56769"] ? Math.round(this.state.casinoData["56769"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56769"] ? Math.round(this.state.casinoData["56769"].maxProfit) : "00"}</span></td>

															</tr>
															<tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/56969"} className=" topboxlink">Hi Low (Virtual)</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56969"] ? this.state.casinoData["56969"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["56969"] && this.state.casinoData["56969"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["56969"] ? Math.round(this.state.casinoData["56969"].exposure) : "00"}</span></span>
																</td><td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56969"] ? Math.round(this.state.casinoData["56969"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56969"] ? Math.round(this.state.casinoData["56969"].maxProfit) : "00"}</span></td>

															</tr>
															<tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/67563"} className=" topboxlink">Poker (Virtual)</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["67563"] ? this.state.casinoData["67563"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["67563"] && this.state.casinoData["67563"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["67563"] ? Math.round(this.state.casinoData["67563"].exposure) : "00"}</span></span>
																</td> <td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["67563"] ? Math.round(this.state.casinoData["67563"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["67563"] ? Math.round(this.state.casinoData["67563"].maxProfit) : "00"}</span></td>

															</tr>
															<tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/92036"} className=" topboxlink">Matka (Virtual)</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["92036"] ? this.state.casinoData["92036"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["92036"] && this.state.casinoData["92036"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["92036"] ? Math.round(this.state.casinoData["92036"].exposure) : "00"}</span></span>
																</td><td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["92036"] ? Math.round(this.state.casinoData["92036"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["92036"] ? Math.round(this.state.casinoData["92036"].maxProfit) : "00"}</span></td>

															</tr>
															<tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/98793"} className=" topboxlink">7 up & Down (Virtual)</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["98793"] ? this.state.casinoData["98793"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["98793"] && this.state.casinoData["98793"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["98793"] ? Math.round(this.state.casinoData["98793"].exposure) : "00"}</span></span>
																</td><td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["98793"] ? Math.round(this.state.casinoData["98793"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["98793"] ? Math.round(this.state.casinoData["98793"].maxProfit) : "00"}</span></td>

															</tr>

															<tr>
																<td><span className="font-weight-bold"><a href={"/casinoanalysisuser/56966"} className=" topboxlink">32 cards casino (Virtual)</a></span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56966"] ? this.state.casinoData["56966"].orderCount : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold"><span className={!!this.state.casinoData["56966"] && this.state.casinoData["56966"].exposure < 0 ? "text-red" : "text-green"}>{!!this.state.casinoData["56966"] ? Math.round(this.state.casinoData["56966"].exposure) : "00"}</span></span>
																</td><td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56966"] ? Math.round(this.state.casinoData["56966"].totalAmount) : "00"}</span></td>
																<td className="text-right"><span className="font-weight-bold">{!!this.state.casinoData["56966"] ? Math.round(this.state.casinoData["56966"].maxProfit) : "00"}</span></td>

															</tr> */}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Footer />
			</div>

		)
	}
}
function mapStateToProps(state) {
	return {
	};
}
function mapDispatchToProps(dispatch) {
	return {
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(CasinoAnalysis);